import {Box, Flex} from '@chakra-ui/react';
import React from 'react';
import {colors} from 'theme';

export const SidebarSkeleton = () => {
  return (
    <>
      {[...Array(30)].map((_, idx) => (
        <Flex key={idx} alignItems="center" p="8px" borderRadius="8px" mb="5px">
          <Box width="36px" height="36px" borderRadius="6px" bg={colors.lightGray} mr="10px" />
          <Box height="16px" width="120px" borderRadius="4px" bg={colors.lightGray} />
        </Flex>
      ))}
    </>
  );
};

export default SidebarSkeleton;
